import {
  _getFullUserHash,
  _normalizeUser,
  type StatsigClient,
  type StatsigUser,
} from "@statsig/react-bindings";

/**
 * True when the data adapter holds prefetched values computed for exactly
 * `user`. `prefetchData` resolves even when the request fails, and a failure
 * leaves whatever was already cached under the same key — the server bootstrap,
 * or an earlier prefetch for a different user (the key is only userID +
 * customIDs). Switching onto either would serve values computed for someone
 * else, so match the full user hash, not just the `Prefetch` source.
 */
const hasPrefetchedValuesFor = (
  client: StatsigClient,
  user: StatsigUser,
): boolean => {
  const cached = client.dataAdapter.getDataSync(user);
  return (
    cached?.source === "Prefetch" &&
    cached.fullUserHash ===
      _getFullUserHash(_normalizeUser(user, client.getContext().options))
  );
};

export { hasPrefetchedValuesFor };
